/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Extraction } from './Extraction.js';
import {
    ExtractionFromJSON,
    ExtractionFromJSONTyped,
    ExtractionToJSON,
} from './Extraction.js';

/**
 * 
 * @export
 * @interface SuggestionSource
 */
export interface SuggestionSource {
    /**
     * 
     * @type {number}
     * @memberof SuggestionSource
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof SuggestionSource
     */
    extractionId?: number;
    /**
     * 
     * @type {string}
     * @memberof SuggestionSource
     */
    extensionId?: string;
    /**
     * 
     * @type {number}
     * @memberof SuggestionSource
     */
    generatorId?: number;
    /**
     * 
     * @type {Extraction}
     * @memberof SuggestionSource
     */
    extraction?: Extraction;
}

/**
 * Check if a given object implements the SuggestionSource interface.
 */
export function instanceOfSuggestionSource(value: object): boolean {
    return true;
}

export function SuggestionSourceFromJSON(json: any): SuggestionSource {
    return SuggestionSourceFromJSONTyped(json, false);
}

export function SuggestionSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuggestionSource {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'extractionId': json['extractionId'] == null ? undefined : json['extractionId'],
        'extensionId': json['extensionId'] == null ? undefined : json['extensionId'],
        'generatorId': json['generatorId'] == null ? undefined : json['generatorId'],
        'extraction': json['extraction'] == null ? undefined : ExtractionFromJSON(json['extraction']),
    };
}

export function SuggestionSourceToJSON(value?: SuggestionSource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'extractionId': value['extractionId'],
        'extensionId': value['extensionId'],
        'generatorId': value['generatorId'],
        'extraction': ExtractionToJSON(value['extraction']),
    };
}

